var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49369 12.269L10.5983 10.1644L14.0763 12.5901L13.2961 13.3703C12.7764 13.89 12.0136 14.0828 11.3094 13.8724C9.15657 13.2293 7.22265 12.0502 5.50765 10.3352C3.79265 8.62022 2.61359 6.68631 1.97046 4.5335C1.76008 3.82931 1.95288 3.06648 2.47255 2.5468L3.25275 1.7666L5.67848 5.24461L3.5739 7.34919",
    stroke: "#2329D6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconBlue);
export default __webpack_public_path__ + "static/media/phone-icon-blue.cd79cb13870a9021d95d0b809342eff9.svg";
export { ForwardRef as ReactComponent };